import { render, staticRenderFns } from "./list-item-title.vue?vue&type=template&id=32fe8ec0&scoped=true"
import script from "./list-item-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-item-title.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./list-item-title.vue?vue&type=style&index=0&id=32fe8ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe8ec0",
  null
  
)

export default component.exports